module.exports = __webpack_public_path__ + "static/2-7949c4db9eb46dfd9e37b4ba7e34fbe0.jpg";